import * as React from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Cookies from 'js-cookie';


function LoginRedirect({ provider }: { provider?: 'microsoft' | 'dentally' }) {
    const queryClient = useQueryClient();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const hasStartedLogin = React.useRef(false);

    const login = useMutation(
        () => {
            return axios.post('/auth', {
                code: searchParams.get("code"),
                provider: provider ?? localStorage.getItem("auth_provider"),
                state: searchParams.get("state"),

            });
        },
        {
        onSuccess: async (authToken) => {
            Cookies.set('token', authToken.data, { expires: 1/3 });
            axios.defaults.headers.common.Authorization = `Bearer ${authToken.data}`;
            queryClient.invalidateQueries({ queryKey: ['user'] });

            const capture = Cookies.get("isCapture");
            console.log("capture",capture);
            if (capture === "true") {
                navigate(`/mobile_uploader`); 
            } else {
                navigate(`/dashboard`);  
            }
        }
        }
    );
    const { mutate } = login;

    React.useEffect(() => {
        if (hasStartedLogin.current) return;
        hasStartedLogin.current = true;
        mutate();
    }, [mutate]);

    return null;
}
export default LoginRedirect;
